import { inject, DestroyRef, Service } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { DeviceService } from './device-detector/device.service';


@Service()
export class AnalyticsService {
  private http = inject(HttpClient);
  private destroyRef = inject(DestroyRef);
  private deviceService = inject(DeviceService);

  private readonly C_I_PERSISTENCE_KEY = 'kl.ci';
  private si: string = null;

  constructor() {
    this.ensureIds();
  }

  private ensureIds(): void {
    if (!this.deviceService.isPlatformBrowser()) {
      return;
    }
    const uid = () => Math.random().toString(36).slice(2);
    const clientId = localStorage.getItem(this.C_I_PERSISTENCE_KEY);
    if (!clientId) {
      const newClientId = uid();
      localStorage.setItem(this.C_I_PERSISTENCE_KEY, newClientId);
    }

    this.si = uid();
  }

  getCi(): string {
    return localStorage.getItem(this.C_I_PERSISTENCE_KEY);
  }

  getSi(): string {
    return this.si;
  }

  addNewRecord(dto: Record<string, unknown>): void {
    if (!this.deviceService.isPlatformBrowser()) {
      return;
    }

    dto.analyticsVersion = 3;
    dto.ci = this.getCi();
    dto.si = this.getSi();

    this.http.post<void>(`${environment.apiHost}/api/v1/analytics`, dto)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }
}
